<template>
  <footer >
    <div v-if="is_hidden" class="footer-card">
      <div class="items-footer">
        <div class="coupons-social">
          <Share label="シェア" :facebook="false" :twitter="false" :favorite="false" :url="urlPath" size="large"/>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: ['is_hidden'],
  data() {
    return {
      menuNum: null,
      urlPath: null,
      menuNo: null
    }
  },
  mounted() {
    const params = this.$route.params
    this.menuNo = params.orderNo
    this.urlPath = `${location.protocol}//${location.host}/public-stay/menus/${this.menuNo}`
  }, 
  watch: {
  },
  computed: {
    
  },
  methods: {
    gotoPath() {
      const query = this.$route.query
      this.$router.push({path: 'bs-men-02-040', query})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss"
</style>